import React from "react";
import { Megaphone } from "lucide-react";
import AnnouncementComposer from "../../announcements/AnnouncementComposer";

const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

export default function AnnouncementsCaster() {
  return (
    <div className={`${card} lg:col-span-2`}>
      <div className="px-5 py-4 border-b border-white/5 flex items-center gap-2">
        <Megaphone size={14} className="text-[#00ff90]/60" />
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Announcements</span>
      </div>

      <div className="p-5">
        <AnnouncementComposer
          endpoint="/api/admin/announcements"
          compact
          onPosted={() => {
            window.dispatchEvent(new CustomEvent("announcement_posted"));
          }}
        />
      </div>
    </div>
  );
}
